var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _vm.viewMode == "list"
                ? _c("span", { staticClass: "ik-list-title" }, [
                    _c(
                      "span",
                      { staticClass: "svg-container ik-list-icon" },
                      [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                      1
                    ),
                    _c("span", [_vm._v("数据列表")]),
                  ])
                : _vm._e(),
              _vm.viewMode === "list"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listCreateBtn },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listUpdateBtn },
                        },
                        [_vm._v("修改")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDetailsBtn },
                        },
                        [_vm._v("详情")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDeleteBtn },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode === "info"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCreateBtn },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoUpdateBtn },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCopyBtn },
                            },
                            [_vm._v("复制")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _vm.mode == "add" || _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoSaveBtn },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.infoCancelBtn },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _vm.viewMode == "info"
                ? _c(
                    "el-form",
                    {
                      staticClass: "ik-info-head",
                      attrs: {
                        id: "ik-info-head",
                        inline: true,
                        "label-width": "120px",
                        disabled: _vm.mode == "details",
                      },
                      on: { validate: _vm.validate },
                      model: {
                        value: _vm.data.head,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "head", $$v)
                        },
                        expression: "data.head",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_id",
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  "default-value": 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["id"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "id", $$v)
                                  },
                                  expression: "data.head['id']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_code",
                                attrs: {
                                  code: "code",
                                  name: "编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["code"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "code", $$v)
                                  },
                                  expression: "data.head['code']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_name",
                                attrs: {
                                  code: "name",
                                  name: "名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["name"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "name", $$v)
                                  },
                                  expression: "data.head['name']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_storeCode",
                                attrs: {
                                  url: "base/user/user/store/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  code: "storeCode",
                                  name: "门店编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["storeCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeCode", $$v)
                                  },
                                  expression: "data.head['storeCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_storeName",
                                attrs: {
                                  code: "storeName",
                                  name: "门店名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["storeName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeName", $$v)
                                  },
                                  expression: "data.head['storeName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_prescriptionSource",
                                attrs: {
                                  code: "prescriptionSource",
                                  name: "方剂出处",
                                  "default-value": "",
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["prescriptionSource"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "prescriptionSource",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['prescriptionSource']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_prescriptionTypeSign",
                                attrs: {
                                  code: "prescriptionTypeSign",
                                  name: "方剂类型",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(
                                    _vm.jsonStr.prescriptionTypeSign
                                  ),
                                  disabled: true,
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["prescriptionTypeSign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "prescriptionTypeSign",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['prescriptionTypeSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_decoctSign",
                                attrs: {
                                  code: "decoctSign",
                                  name: "加工方式",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(_vm.jsonStr.decoctSign),
                                  require: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["decoctSign"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "decoctSign", $$v)
                                  },
                                  expression: "data.head['decoctSign']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "treatment-form-item",
                                  attrs: { label: "主诉" },
                                },
                                [
                                  _c("key-word", {
                                    attrs: { code: "sym" },
                                    on: { change: _vm.onFieldChange },
                                    model: {
                                      value: _vm.data.head["symContent"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data.head,
                                          "symContent",
                                          $$v
                                        )
                                      },
                                      expression: "data.head['symContent']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "treatment-form-item",
                                  attrs: { label: "既往史" },
                                },
                                [
                                  _c("key-word", {
                                    attrs: { code: "his" },
                                    on: { change: _vm.onFieldChange },
                                    model: {
                                      value: _vm.data.head["hisContent"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data.head,
                                          "hisContent",
                                          $$v
                                        )
                                      },
                                      expression: "data.head['hisContent']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "treatment-form-item",
                                  attrs: { label: "家族史" },
                                },
                                [
                                  _c("key-word", {
                                    attrs: { code: "family" },
                                    on: { change: _vm.onFieldChange },
                                    model: {
                                      value: _vm.data.head["familyContent"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data.head,
                                          "familyContent",
                                          $$v
                                        )
                                      },
                                      expression: "data.head['familyContent']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "treatment-form-item",
                                  attrs: { label: "体质" },
                                },
                                [
                                  _c("key-word", {
                                    attrs: { code: "phy", "label-width": 180 },
                                    on: { change: _vm.onFieldChange },
                                    model: {
                                      value: _vm.data.head["phyContent"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data.head,
                                          "phyContent",
                                          $$v
                                        )
                                      },
                                      expression: "data.head['phyContent']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "treatment-form-item",
                                  attrs: { label: "四诊" },
                                },
                                [
                                  _c("key-word", {
                                    attrs: { code: "fdm" },
                                    on: { change: _vm.onFieldChange },
                                    model: {
                                      value: _vm.data.head["fdmContent"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data.head,
                                          "fdmContent",
                                          $$v
                                        )
                                      },
                                      expression: "data.head['fdmContent']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "treatment-form-item",
                                  attrs: { label: "诊断" },
                                },
                                [
                                  _c("key-word", {
                                    attrs: { id: "key3", code: "diag" },
                                    on: { change: _vm.onFieldChange },
                                    model: {
                                      value: _vm.data.head["diagContent"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data.head,
                                          "diagContent",
                                          $$v
                                        )
                                      },
                                      expression: "data.head['diagContent']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "treatment-form-item",
                                  attrs: { label: "中医病" },
                                },
                                [
                                  _c("key-word", {
                                    attrs: { code: "chDiag" },
                                    model: {
                                      value: _vm.data.head["chDiagContent"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data.head,
                                          "chDiagContent",
                                          $$v
                                        )
                                      },
                                      expression: "data.head['chDiagContent']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "treatment-form-item",
                                  attrs: { label: "中医症" },
                                },
                                [
                                  _c("key-word", {
                                    attrs: { code: "chYndrome" },
                                    model: {
                                      value: _vm.data.head["cChYndromeContent"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data.head,
                                          "cChYndromeContent",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.head['cChYndromeContent']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "treatment-form-item",
                                  attrs: { label: "治法" },
                                },
                                [
                                  _c("key-word", {
                                    attrs: { code: "chTherapy" },
                                    model: {
                                      value: _vm.data.head["chTherapyContent"],
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.data.head,
                                          "chTherapyContent",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "data.head['chTherapyContent']",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_dayNum",
                                attrs: {
                                  code: "dayNum",
                                  name: "用药天数",
                                  "default-value": 0,
                                  precision: 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["dayNum"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "dayNum", $$v)
                                  },
                                  expression: "data.head['dayNum']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_dayDoseNum",
                                attrs: {
                                  code: "dayDoseNum",
                                  name: "每日剂量",
                                  "default-value": 0,
                                  precision: 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["dayDoseNum"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "dayDoseNum", $$v)
                                  },
                                  expression: "data.head['dayDoseNum']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_dayFreq",
                                attrs: {
                                  code: "dayFreq",
                                  name: "每日次数",
                                  "default-value": 0,
                                  precision: 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["dayFreq"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "dayFreq", $$v)
                                  },
                                  expression: "data.head['dayFreq']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_doseNum",
                                attrs: {
                                  code: "doseNum",
                                  name: "剂数",
                                  "default-value": 0,
                                  precision: 0,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["doseNum"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "doseNum", $$v)
                                  },
                                  expression: "data.head['doseNum']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode == "info"
                ? _c(
                    "el-tabs",
                    {
                      ref: "ik-info-body",
                      staticClass: "std-prescription-tabs-info",
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          key: _vm.bodyMap[0].key,
                          staticStyle: { height: "100%" },
                          attrs: {
                            name: _vm.bodyMap[0].key,
                            label: _vm.bodyMap[0].name,
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                                {
                                  name: "horizontal-scroll",
                                  rawName: "v-horizontal-scroll",
                                  value: "always",
                                  expression: "'always'",
                                },
                              ],
                              ref: "tablesub",
                              staticClass: "ik-list-table",
                              attrs: {
                                data: _vm.data.body[_vm.bodyMap[0].key],
                                "element-loading-text": "加载中...",
                                stripe: true,
                                border: true,
                                fit: true,
                                height: "100%",
                                "header-row-class-name":
                                  "ik-list-table-header-row",
                                "header-cell-class-name":
                                  "ik-list-table-header-cell",
                                "row-class-name": "ik-list-table-body-row",
                                "cell-class-name": "ik-list-table-body-cell",
                                "highlight-current-row": true,
                              },
                            },
                            [
                              _vm.mode !== "details"
                                ? _c("el-table-column", {
                                    attrs: {
                                      prop: "pluss",
                                      label: "操作",
                                      width: "180",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "header",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "button-action",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        padding: "0px 12px",
                                                      },
                                                    },
                                                    [_vm._v("操作")]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "26px",
                                                        height: "26px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: {
                                                        circle: "",
                                                        title: "添加首行",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addRow(
                                                            _vm.activeTab,
                                                            -1
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("+")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "button-action",
                                                },
                                                [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "28px",
                                                        height: "28px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: { circle: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.addRow(
                                                            _vm.bodyMap[0].key,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("+")]
                                                  ),
                                                  _c(
                                                    "el-button",
                                                    {
                                                      style: {
                                                        width: "28px",
                                                        height: "28px",
                                                        color: "#409EFF",
                                                        padding: "3px 0",
                                                        "margin-top": "3px",
                                                      },
                                                      attrs: { circle: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.delRow(
                                                            _vm.bodyMap[0].key,
                                                            scope.$index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("-")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2391271428
                                    ),
                                  })
                                : _vm._e(),
                              _c("ik-column-id", {
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  edit: _vm.mode !== "details",
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "materielCode",
                                  name: "药品编码",
                                  edit: false,
                                },
                                on: { onFieldChange: _vm.onBodyFieldChange },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "materielName",
                                  name: "药品名称",
                                  url: "clinic/clinicdic/clinicmedicinedic/clinicmateriel/find/findPagination",
                                  "filed-list": [
                                    { code: "materielCode", name: "编码" },
                                    { code: "materielName", name: "名称" },
                                  ],
                                  "search-key": "materielName",
                                  searcher: {
                                    storeCode: _vm.storeCode,
                                    effectiveSign: "1",
                                    materielTypeSign:
                                      _vm.data.head["positionClassifySign"],
                                  },
                                  edit: _vm.mode !== "details",
                                },
                                on: {
                                  onFieldChange: _vm.onBodyFieldChange,
                                  onPopupClick: _vm.bodyPopupClick,
                                },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "decoctionCode",
                                  name: "煎法编码",
                                  edit: _vm.mode !== "details",
                                },
                              }),
                              _c("ik-column-data-popup", {
                                attrs: {
                                  code: "decoctionName",
                                  name: "煎法名称",
                                  url: "clinic/clinicdic/clinicmedicinedic/clinicmeddic/find/findPagination",
                                  "filed-list": [
                                    { code: "medDictionaryCode", name: "编码" },
                                    { code: "medDictionaryName", name: "名称" },
                                  ],
                                  "search-key": "medDictionaryName",
                                  searcher: {
                                    storeCode: _vm.data.head["storeCode"],
                                    medDirectoryCode: "JZ",
                                    effectiveSign: "1",
                                  },
                                  edit: _vm.mode !== "details",
                                },
                                on: { onPopupClick: _vm.bodyPopupClick },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "medUomCode",
                                  name: "药品单位编码",
                                  edit: _vm.mode !== "details",
                                },
                              }),
                              _c("ik-column-text", {
                                attrs: {
                                  code: "medUomName",
                                  name: "药品单位名称",
                                  edit: _vm.mode !== "details",
                                },
                              }),
                              _c("ik-column-number", {
                                attrs: {
                                  code: "singleNum",
                                  name: "单剂数量",
                                  edit: _vm.mode !== "details",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "querybg" },
                [
                  _vm.viewMode == "list"
                    ? _c(
                        "el-collapse",
                        {
                          staticClass: "ik-list-searcher",
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.searcherActive,
                            callback: function ($$v) {
                              _vm.searcherActive = $$v
                            },
                            expression: "searcherActive",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "ik-list-searcher-item",
                              attrs: { title: "", name: "1" },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ik-list-searcher-item-titles",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "svg-container ik-list-icon",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "search" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" 查询条件 "),
                                  ]
                                ),
                              ]),
                              _c(
                                "el-form",
                                {
                                  staticClass: "ik-info-head",
                                  attrs: {
                                    id: "ik-info-head",
                                    inline: true,
                                    "label-width": "120px",
                                    disabled: false,
                                  },
                                  model: {
                                    value: _vm.searcher,
                                    callback: function ($$v) {
                                      _vm.searcher = $$v
                                    },
                                    expression: "searcher",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_code",
                                            attrs: {
                                              code: "code",
                                              name: "编码",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["code"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "code",
                                                  $$v
                                                )
                                              },
                                              expression: "searcher['code']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_name",
                                            attrs: {
                                              code: "name",
                                              name: "名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["name"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "name",
                                                  $$v
                                                )
                                              },
                                              expression: "searcher['name']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_decoctSign",
                                            attrs: {
                                              code: "decoctSign",
                                              name: "代加工",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.decoctSign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["decoctSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "decoctSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['decoctSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "query-class" }, [
                                _c(
                                  "div",
                                  { staticClass: "query-btn-warp" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.searchBtn },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.resetBtn },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.viewMode == "list"
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "table",
                      staticClass: "ik-list-table",
                      attrs: {
                        data: _vm.tableData,
                        "element-loading-text": "加载中...",
                        stripe: true,
                        border: true,
                        fit: true,
                        height: "calc(100% - 50px)",
                        "header-row-class-name": "ik-list-table-header-row",
                        "header-cell-class-name": "ik-list-table-header-cell",
                        "row-class-name": "ik-list-table-body-row",
                        "cell-class-name": "ik-list-table-body-cell",
                        "highlight-current-row": true,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("ik-column-id", {
                        attrs: { code: "id", name: "ID", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "code", name: "编码", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "name", name: "名称", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "storeCode",
                          name: "门店编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "storeName",
                          name: "门店名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "prescriptionSource",
                          name: "方剂出处",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "prescriptionTypeSign",
                          name: "方剂类型",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.prescriptionTypeSign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "decoctSign",
                          name: "加工类型",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.decoctSign),
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "symContent",
                          name: "主诉",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "code", name: "既往史", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "familyContent",
                          name: "家族史",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "phyContent",
                          name: "体质",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "fdmContent",
                          name: "四诊",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "diagContent",
                          name: "西医病",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "chDiagContent",
                          name: "中医病",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "chYndromeContent",
                          name: "中医证",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "chTherapyContent",
                          name: "治法",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "dayNum",
                          name: "用药天数",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "dayDoseNum",
                          name: "每日剂数",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "dayFreq",
                          name: "每日次数",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: { code: "doseNum", name: "剂数", edit: false },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _vm.viewMode == "list"
                ? _c("ik-pagination", {
                    ref: "ik_list_pagination",
                    attrs: {
                      "page-no": _vm.pagination.pageNo,
                      "page-size": _vm.pagination.pageSize,
                      "total-count": _vm.pagination.totalCount,
                    },
                    on: { pageChangeMethod: _vm.pageChange },
                  })
                : _c(
                    "el-row",
                    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "ik-list-enterprise-info",
                          attrs: { span: 6, offset: 12 },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" 导萃门诊管理系统 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }